import React from 'react';
import { FormikProps } from 'formik';
import { Seguradora } from '@/types/SeguradoraDTO';
import { SectionTitle } from '@/components/ui/section-title';
import { ActionButton, Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { EmailContatoDTO } from '@/types/EmailContatoDTO';
import { FormikInput } from '@/components/ui/input';
import { CheckIcon, PencilIcon, TrashIcon, Plus, Mail } from 'lucide-react';

type SeguradoraEmailSectionParams = {
    formikProps: FormikProps<Seguradora>;
    novo: () => void;
    salvar: () => void;
    alterar: (index: number) => void;
    remover: (index: number) => void;
    loading: boolean;
    indexEditando: number|undefined;
}

const SeguradoraEmailSection: React.FC<SeguradoraEmailSectionParams> = ({
    novo, alterar, remover, salvar, formikProps, loading, indexEditando
}) => {
    return (
        <>
            <SectionTitle hasButton icon={<Mail />} cor="bg-violet-500/10 text-violet-600 dark:text-violet-400">
                Emails
                <Button type="button" variant="outline" size="sm" className="disabled:hidden" onClick={novo}><Plus className="mr-1.5 h-4 w-4" /> Adicionar</Button>
            </SectionTitle>
            {formikProps.values.emails?.length > 0 && (                                
                <Card className='w-full overflow-hidden shadow-none'>
                    <Table className="tabela-empilhada">
                        <TableHeader>
                            <TableRow>
                                <TableHead>Descrição</TableHead>
                                <TableHead>Email</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {formikProps.values.emails.map((email, index) => (
                                <TableRow key={`email-${index}`}>
                                    <TableCell data-label="Descrição">
                                        {indexEditando===index ? (
                                            <FormikInput showError={false}  name={`emails.${index}.descricao`} value={formikProps.values.emails[index].descricao}/>
                                        ): (
                                            <>                                        
                                                {email.descricao}
                                                {formikProps.errors.emails && formikProps.errors.emails[index] && (formikProps.errors.emails[index] as EmailContatoDTO).descricao &&(
                                                    <div className='mt-1 text-xs font-medium text-destructive'>{`${(formikProps.errors.emails[index] as EmailContatoDTO).descricao}`}</div>
                                                )}                                                                
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell data-label="Email">
                                        {indexEditando===index ? (
                                            <FormikInput showError={false} name={`emails.${index}.email`} value={formikProps.values.emails[index].email} />
                                        ): (
                                            <>
                                                {email.email}
                                                {formikProps.errors.emails && formikProps.errors.emails[index] && (formikProps.errors.emails[index] as EmailContatoDTO).email &&(
                                                    <div className='mt-1 text-xs font-medium text-destructive'>{`${(formikProps.errors.emails[index] as EmailContatoDTO).email}`}</div>
                                                )}                                                                
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell className='text-right'>
                                        {index === indexEditando ? (
                                            <>
                                            <ActionButton icon={<CheckIcon className="h-3.5 w-3.5" />} label='Salvar Email' onClick={() => salvar()} />
                                            </>
                                        ) : (
                                            <>
                                            <ActionButton icon={<PencilIcon className="h-3.5 w-3.5" />} label='Editar' onClick={() => alterar(index)} />
                                            <ActionButton variant='destructive' icon={<TrashIcon className="h-3.5 w-3.5" />} label='Remover' onClick={() => remover(index)} />
                                            </>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Card>
            )}                              
        </>
    );
}

export default SeguradoraEmailSection;